import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  class: "app-page sweet"
};
var _hoisted_2 = {
  class: "compon-menu"
};
var _hoisted_3 = ["onClick"];
var _hoisted_4 = {
  key: 0,
  class: "component-content"
};
import XTableExample from './components/x-table-example/XTableExample.vue';

import { shallowRef } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Sweet',
  setup: function setup(__props) {
    var currentComponent = shallowRef();
    // 基础组件
    var baseComponent = [{
      label: '容器',
      component: ''
    }];
    var dataShowComponent = [{
      label: 'XTable 表格',
      component: XTableExample
    }];
    function setCurrentComponent(component) {
      currentComponent.value = component;
    }
    return function (_ctx, _cache) {
      var _component_el_scrollbar = _resolveComponent("el-scrollbar");
      var _component_XFlexCtx = _resolveComponent("XFlexCtx");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "title"
      }, "基础组件", -1)), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(baseComponent, function (item, index) {
        return _createElementVNode("div", {
          class: "item",
          key: index
        }, _toDisplayString(item.label), 1);
      }), 64))]), _createElementVNode("div", null, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "title"
      }, "数据展示", -1)), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(dataShowComponent, function (item, index) {
        return _createElementVNode("div", {
          class: "item",
          key: index,
          onClick: function onClick($event) {
            return setCurrentComponent(item.component);
          }
        }, _toDisplayString(item.label), 9, _hoisted_3);
      }), 64))])]), _createVNode(_component_XFlexCtx, {
        flex: 1
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_scrollbar, {
            height: "100%"
          }, {
            default: _withCtx(function () {
              return [_unref(currentComponent) ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(), _createBlock(_resolveDynamicComponent(_unref(currentComponent))))])) : _createCommentVNode("", true)];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "component-content-list"
      }, null, -1))]);
    };
  }
});